import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import client from './contentfulClient';

const PostProductionDetails = () => {
  const { id } = useParams();
  const [project, setProject] = useState(null);

  useEffect(() => {
    client
      .getEntry(id)
      .then((entry) => {
        setProject(entry.fields);
      })
      .catch(console.error);
  }, [id]);

  if (!project) return <p>Loading...</p>;

  const { title, description, videoUrl, stills, thumbnail } = project;

  // ✅ Function to clean and convert any YouTube link to an embed-friendly one
  const getCleanYouTubeEmbedUrl = (url) => {
    // Handle already embed URLs but remove ?si or any query params
    const embedMatch = url.match(/youtube\.com\/embed\/([\w-]+)/);
    if (embedMatch && embedMatch[1]) {
      return `https://www.youtube.com/embed/${embedMatch[1]}`;
    }

    // Handle normal YouTube watch URLs
    const watchMatch = url.match(/youtube\.com\/watch\?v=([\w-]+)/);
    if (watchMatch && watchMatch[1]) {
      return `https://www.youtube.com/embed/${watchMatch[1]}`;
    }

    // Handle shortened youtu.be URLs
    const shortMatch = url.match(/youtu\.be\/([\w-]+)/);
    if (shortMatch && shortMatch[1]) {
      return `https://www.youtube.com/embed/${shortMatch[1]}`;
    }

    // If none matched, return as-is
    return url;
  };

  return (
    <>
      <section className="production-video">
        <div className="iframe-container">
          <iframe
            src={getCleanYouTubeEmbedUrl(videoUrl)}
            width="560"
            height="315"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title={title}
          />
        </div>
      </section>

      <section className="text-center productive-description">
        <h2>{title}</h2>
        <p>{description}</p>
      </section>

      <section className="image-sliders">
        <div className="container">
          <h2>Stills</h2>
        </div>

        <div className="scroller" id="scroller">
          <div className="scroller-track" id="scroller-track">
          {stills && stills.length > 0 ? (
  stills.map((image, index) => {
    const imageUrl = image.fields.file.url;
    const optimizedUrl = `https:${imageUrl}?w=600&q=75&fm=webp`;

    return (
      <img
        key={index}
        src={optimizedUrl}
        alt={image.fields.title || `Still ${index + 1}`}
        loading="lazy"
      />
    );
  })
) : (
  <p>No stills available.</p>
)}

          </div>
        </div>
      </section>
    </>
  );
};

export default PostProductionDetails;
